import React from "react";

const LogoSvg = () => {
  return (
    <svg
      className="mr-2 fill-current text-blue hover:text-blue-lighter"
      width="60"
      height="59"
      viewBox="0 0 60 59"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d)">
        <path d="M54.5155 3.51547H4V53H54.5155V3.51547Z" fill="#37ACF4" />
        <path
          d="M55.031 3H4.5155V52.4845H55.031V3Z"
          stroke="#37ACF4"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M48.3155 7.77936C33.9206 7.77936 33.532 46.8144 33.532 46.8144H45.2031C45.2031 46.8144 39.1732 7.84431 50.6505 7.84431"
          fill="white"
        />
        <path
          d="M45.2031 7.63916C38.1505 7.63916 32.7258 10.8474 28.5722 15.267C21.2938 20.6938 9.41034 46.8144 9.41034 46.8144H15.6351H25.7505C25.7505 46.8144 37.6176 7.63916 46.565 7.63916H45.2031Z"
          fill="white"
        />
        <path
          d="M40.0093 27.3371C36.4691 22.6577 26.5536 29.9536 26.5536 29.9536L29.4237 33.7495C29.4237 33.7495 37.7598 24.3639 40.5814 28.0979"
          fill="white"
        />
      </g>
      <defs>
        <filter
          id="filter0_d"
          x="0"
          y="0.5"
          width="59.531"
          height="58.5"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default LogoSvg;
